import { IOrganization } from 'types';
import { IAdditionalInformation } from 'types/domain/additionalInformation';
import { IKnowledgeAreaLevel } from 'types/domain/knowledgeAreaLevel';

const KNOWLEDGE_AREA_CATEGORY_NAME = {
  TECHNICAL: 'Technical Skills',
  SOFT: 'Soft Skills',
};

const KNOWLEDGE_AREA_CATEGORY_ID = {
  TECHNICAL: 1,
  SOFT: 2,
};

type KnowledgeAreaCategoryName =
  | typeof KNOWLEDGE_AREA_CATEGORY_NAME.SOFT
  | typeof KNOWLEDGE_AREA_CATEGORY_NAME.TECHNICAL;

type KnowledgeAreaCategoryId =
  | typeof KNOWLEDGE_AREA_CATEGORY_ID.TECHNICAL
  | typeof KNOWLEDGE_AREA_CATEGORY_ID.SOFT;

type KnowledgeAreaCategoryNames = [
  typeof KNOWLEDGE_AREA_CATEGORY_NAME.SOFT,
  typeof KNOWLEDGE_AREA_CATEGORY_NAME.TECHNICAL,
];

interface IKnowledgeAreaCategory {
  id: KnowledgeAreaCategoryId;
  name: KnowledgeAreaCategoryName;
}

interface IKnowledgeArea {
  id: number;
  name: string;
  category: KnowledgeAreaCategoryName;
  description: string;
  organization: IOrganization;
  levels: IKnowledgeAreaLevel[];
  isChecked?: boolean;
}

interface IKnowledge {
  id: number;
  name: string;
  description: string;
  category: KnowledgeAreaCategoryName | IKnowledgeAreaCategory;
  organization: IOrganization;
  levels: IKnowledgeAreaLevel[];
}

interface ISelectedLevel {
  id: number;
  name: string;
  orderNo: number;
  exercises: IExercise[];
}

interface IExercise {
  id: number;
  name: string;
  description: string;
  exCategory: IExCategory;
}

interface IExCategory {
  id: number;
  name: string;
}

interface IKnowledgeAreaNew {
  id: number;
  knowledge: IKnowledge;
  selectedLevel: ISelectedLevel[];
  orderNo: number;
}

interface IKnowledgeAreaDetails extends IKnowledgeArea, IAdditionalInformation {}

export { KNOWLEDGE_AREA_CATEGORY_NAME };
export type {
  IKnowledgeArea,
  KnowledgeAreaCategoryName,
  IKnowledgeAreaDetails,
  KnowledgeAreaCategoryId,
  KnowledgeAreaCategoryNames,
  IKnowledgeAreaNew,
  IKnowledge,
  ISelectedLevel,
};
